module.exports = __webpack_public_path__ + "videos/participant-testing.5d2adb1.webm";